// extracted by mini-css-extract-plugin
export var deliveryRow = "_qa-a";
export var fixedHeight = "_qa-4";
export var freightLogo = "_qa-9";
export var fullWidth = "_qa-3";
export var priceColumn = "_qa-5";
export var radioSelected = "_qa-7";
export var radioUnselected = "_qa-6";
export var selectedOption = "_qa-2";
export var selectedOptionContainer = "_qa-1";
export var selection = "_qa-0";
export var tallSkeletonText = "_qa-8";